"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_PARTITION_COUNT = exports.DEFAULT_PARTITION_COUNT = void 0;
exports.ensureValidStreamPartitionIndex = ensureValidStreamPartitionIndex;
exports.ensureValidStreamPartitionCount = ensureValidStreamPartitionCount;
exports.DEFAULT_PARTITION_COUNT = 1;
exports.MAX_PARTITION_COUNT = 100;
function ensureValidStreamPartitionIndex(streamPartition) {
    if (!Number.isSafeInteger(streamPartition) || streamPartition < 0 || streamPartition >= exports.MAX_PARTITION_COUNT) {
        throw new Error(`invalid streamPartition value: ${streamPartition}`);
    }
}
function ensureValidStreamPartitionCount(streamPartition) {
    if (!Number.isSafeInteger(streamPartition) || streamPartition < 0 || streamPartition > exports.MAX_PARTITION_COUNT) {
        throw new Error(`invalid streamPartition value: ${streamPartition}`);
    }
}
//# sourceMappingURL=partition.js.map